import { PasswordSettingForm } from "../../organisms/form/PasswordSettingForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { usePasswordSetting } from "./hook";

export const PasswordSettingPage: React.FC = () => {
  const { handlePasswordSetting } = usePasswordSetting();

  return (
    <CardTemplate title="パスワード設定">
      <PasswordSettingForm handleSubmit={handlePasswordSetting} />
    </CardTemplate>
  );
};
